import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { KubernetesIcon, RocketIcon } from "@octopusdeploy/design-system-icons";
import { colorScales, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import CreateSampleProjectCallout from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/Areas/Projects/components/CreateSampleProjectCallout";
import ImageWithPlaceholder from "~/components/GettingStarted/ImageWithPlaceholder/ImageWithPlaceholder";
import image from "../../Images/Projects.svg";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "./CommonViews";
export const CommonProjectsView = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="OnboardingProjectsLearnMore">Projects</ExternalLink> let you manage multiple software applications. For each project, you define a deployment process, configuration variables, and the environments the software
                    will be deployed to.
                </p>
                <div>
                    <CreateSampleProjectCallout />
                </div>
                <ImageWithPlaceholder src={image} alt={"Projects"}/>
            </OverviewHighlightText>
        </OverviewContainer>);
};
const topicsStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space[8],
    color: themeTokens.color.text.secondary,
});
const linkStyles = css({
    display: "flex",
    gap: space[4],
    alignItems: "center",
});
export const CommonProjectsTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources title="Getting Started Guides">
                <div className={topicsStyles}>
                    <div className={linkStyles}>
                        <KubernetesIcon size={20} color={colorScales.blue["500"]}/>
                        <ExternalLink href="FirstKubernetesGuide">First Kubernetes Deployment</ExternalLink>
                    </div>
                    <div className={linkStyles}>
                        <RocketIcon size={20} color={colorScales.blue["500"]}/>
                        <ExternalLink href="FirstDeploymentGuide">First Deployment</ExternalLink>
                    </div>
                </div>
            </LearnMoreResources>
        </TopicsContainer>);
};
